import cn from 'classnames';
import { ArticleHeading1, ArticleHeading3, ArticleParagraph1 } from '@cian/ui-kit';

import { Wrapper } from '../Wrapper';
import { content } from './content';

import * as styles from './styles.css';

export const UsefulRealtor: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Wrapper>
        <div className={styles['title']}>
          <ArticleHeading1>Чем полезен риелтор</ArticleHeading1>
        </div>
        <div className={styles['content']}>
          {content.map((item, index) => {
            return (
              <div key={index} className={styles['item']}>
                <div className={cn(styles['img'], styles[`${item.img}-img`])} />
                <div className={styles['item-title']}>
                  <ArticleHeading3>{item.title}</ArticleHeading3>
                </div>
                <ArticleParagraph1>{item.text}</ArticleParagraph1>
              </div>
            );
          })}
        </div>
      </Wrapper>
    </div>
  );
};

UsefulRealtor.displayName = 'UsefulRealtor';
